import { render } from "./TrafficDetailsTable.vue?vue&type=template&id=a64f9912"
import script from "./TrafficDetailsTable.vue?vue&type=script&lang=js"
export * from "./TrafficDetailsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__